import { useMutation } from '@tanstack/react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { submitLogin, type LoginResponse } from '../api/auth.api';

import type { LoginFlow } from '@/lib/api/kratos';

// Flexible type for login values that allows different combinations
export interface LoginValues {
  method: string;
  identifier?: string;
  password?: string;
  csrf_token?: string;
  [key: string]: unknown; // Allow additional fields for other auth methods
}

/**
 * Hook for handling user login
 * Simplified like Nuxt2 - just handle login and basic redirect
 */
export function useLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const setSession = useAuthStore((state) => state.setSession);

  return useMutation({
    mutationFn: ({ flow, values }: { flow: LoginFlow; values: LoginValues }) =>
      submitLogin(flow, values as any), // Cast to LoginFormValues for API call
    onSuccess: (data: LoginResponse) => {
      console.log('Login mutation success:', data);
      
      // If login successful and we have a session, update store and redirect
      if (data.session) {
        console.log('Login successful, updating auth store...');
        setSession(data.session);
        
        // Simple redirect like Nuxt2 - just go to dashboard
        console.log('Redirecting to dashboard');
        navigate('/dashboard', { replace: true });
      }
      // If we get a flow back, it means we need more input (e.g., method selection)
      // The UI should handle this by showing the updated flow
    },
    onError: (error: any) => {
      // Error handling is done in the component
      console.error('Login error:', error);
    },
  });
}
